import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import {
  checkedListAtom,
  isCheckAllAtom,
  orderByAtom,
  paginationConfigAtom,
  scannerTypeFilterAtom,
  searchPhraseFilterAtom,
  selectedEnpointsFilterAtom,
} from './EPList/state';
import { epTypeAtom, appliedEPIdsAtom } from '../EPDashboard/state';

export function useOnCompanyChangeEpResetAtoms() {
  const resetSelectedHostIds = useResetAtom(appliedEPIdsAtom);
  const resetHostTypeAtom = useResetAtom(epTypeAtom);
  const resetOrderbyAtom = useResetAtom(orderByAtom);
  const resetScannerTypeAtom = useResetAtom(scannerTypeFilterAtom);
  const resetCheckedListAtom = useResetAtom(checkedListAtom);
  const resetIsCheckAllAtom = useResetAtom(isCheckAllAtom);
  const resetSearchPhraseAtom = useResetAtom(searchPhraseFilterAtom);
  const resetSelectedEnpointsFilterAtom = useResetAtom(
    selectedEnpointsFilterAtom,
  );
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);

  const resetAtoms = () => {
    resetSelectedHostIds();
    resetHostTypeAtom();
    resetOrderbyAtom();
    resetScannerTypeAtom();
    resetCheckedListAtom();
    resetIsCheckAllAtom();
    resetSearchPhraseAtom();
    resetSelectedEnpointsFilterAtom();
    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
  };

  return resetAtoms;
}
